module.exports = __webpack_public_path__ + "media/images/application/icons/icon-check-08ca13331145dd356ed9e562282f48f0.svg";